import { Folder } from '@lockton-apps/shared/interfaces';
import { MockedClientDefaultId } from './clients.mock';

export const MOCKED_CLIENT_FOLDERS_DEFAULT: Record<number, Folder[]> = {
  // LSOS
  [MockedClientDefaultId.LsosDefault]: [],

  // NORWAY
  [MockedClientDefaultId.NorwayDefaultCorporateHealthBusiness]: [],
  [MockedClientDefaultId.NorwayDefaultCorporateHealthPrivate]: [],
};
